/**
 * Component is used to show cart summary options on the order confirmation page
 *
 * @param {Array}  [giftOptions] - Array of cart summary options
 * @param {string} [cssModifier] - Css class for cart summary gift option
 * @param {String} [giftOptionTitle] - label used for order summary gift when has no elements inside and showing total price 0
 *
 * HTML Structure Example
 * <e2-order-summary-gift-options
 *      gift-option-title="GIFT WRAP"
 * ></e2-order-summary-gift-options>
 *
 */

import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/order';

import { CartSummaryGiftOptions } from '../cart/CartSummaryGiftOptions';

const mapStateToProps = state => {
    const giftOptionsTotal = selectors.getOrderSummaryGiftOptions(state);

    return {
        giftOptions: giftOptionsTotal.giftOptionTotals || [],
        optionsTotalPrice: giftOptionsTotal.optionsTotalPrice || {},
    };
};

export default () =>
    customElements.define(
        'e2-order-summary-gift-options',
        connect(mapStateToProps)(CartSummaryGiftOptions),
    );
